import { BaseService } from '../base/BaseService';
export class AiAnalyticsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiAnalyticsService.DEFAULT_SERVICE_PATH,
            basePath: AiAnalyticsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getInsightsRaw(request) {
        return this.http.post(this.buildUrl('insights'), request);
    }
    async getInsights(request) {
        const response = await this.getInsightsRaw(request);
        if (!response.data)
            throw new Error('No data returned from analytics');
        return response.data;
    }
    async prioritizeTasksRaw(request) {
        return this.http.post(this.buildUrl('prioritize-tasks'), request);
    }
    async prioritizeTasks(request) {
        const response = await this.prioritizeTasksRaw(request);
        if (!response.data)
            throw new Error('No data returned from prioritize-tasks');
        return response.data;
    }
    async generateAdminInsightsRaw(request) {
        return this.http.post(this.buildUrl('admin-insights'), request);
    }
    async generateAdminInsights(request) {
        const response = await this.generateAdminInsightsRaw(request);
        if (!response.data)
            throw new Error('No data returned from admin-insights');
        return response.data;
    }
    async answerAdminQueryRaw(request) {
        return this.http.post(this.buildUrl('admin-query'), request);
    }
    async answerAdminQuery(request) {
        const response = await this.answerAdminQueryRaw(request);
        if (!response.data)
            throw new Error('No data returned from admin-query');
        return response.data;
    }
}
AiAnalyticsService.DEFAULT_SERVICE_PATH = 'ai-management';
AiAnalyticsService.BASE_PATH = 'api/ai/analytics';
//# sourceMappingURL=AiAnalyticsService.js.map